const customerActivateMutation = /* GraphQL */ `
	mutation customerActivateByUrl($activationUrl: URL!, $password: String!) {
		customerActivateByUrl(activationUrl: $activationUrl, password: $password) {
			customerUserErrors {
				message
				field
				code
			}
		}
	}
`

export default customerActivateMutation
